/**
 * React Query Hook for fetching recommended cases
 * Returns newest active cases for carousel display
 */

import { useQuery } from '@tanstack/react-query';
import { getRecommendedCases } from '@/api/services/casesApi';
import type { GetRecommendedCasesParams } from '@/types/api';

/**
 * Query hook for fetching recommended cases with pagination
 * Uses TanStack Query with caching strategy
 * Cache key: ['recommendedCases', params]
 */
export const useRecommendedCases = (params?: GetRecommendedCasesParams) => {
  return useQuery({
    queryKey: ['recommendedCases', params],
    queryFn: async () => {
      return getRecommendedCases(params);
    },
    retry: 1,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
  });
};
